import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_UploadProcess = _resolveComponent("UploadProcess")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    (_ctx.isLogin)
      ? (_openBlock(), _createBlock(_component_UploadProcess, {
          key: 0,
          ref: "uploadRef"
        }, null, 512))
      : _createCommentVNode("", true)
  ]))
}